module.exports = __webpack_public_path__ + "static/media/3D打印气象站.300a67dc.png";